import { render, staticRenderFns } from "./FunctionsSetting.vue?vue&type=template&id=032db270"
import script from "./FunctionsSetting.vue?vue&type=script&lang=js"
export * from "./FunctionsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports